
import { Union, Record } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { ExternalPerson_$reflection } from "../../../Shared/User.js";
import { union_type, class_type, record_type, list_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { AccountSettings_$reflection, CustomerConfiguration_$reflection, RequestedValue$1_$reflection } from "../../../Shared/Shared.js";
import { PropertyConfiguration_$reflection } from "../../../Shared/PropertyConfiguration.js";

export class State extends Record {
    constructor(ExternalPersons, CustomerConfiguration, PropertyConfigurations, AccountSettings) {
        super();
        this.ExternalPersons = ExternalPersons;
        this.CustomerConfiguration = CustomerConfiguration;
        this.PropertyConfigurations = PropertyConfigurations;
        this.AccountSettings = AccountSettings;
    }
}

export function State_$reflection() {
    return record_type("ToolBox.Overviews.ExternalPerson.Types.State", [], State, () => [["ExternalPersons", RequestedValue$1_$reflection(list_type(ExternalPerson_$reflection()))], ["CustomerConfiguration", RequestedValue$1_$reflection(CustomerConfiguration_$reflection())], ["PropertyConfigurations", RequestedValue$1_$reflection(list_type(PropertyConfiguration_$reflection()))], ["AccountSettings", RequestedValue$1_$reflection(AccountSettings_$reflection())]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ExternalPersonsFetched", "CustomerConfigurationFetched", "PropertyConfigurationsFetched", "AccountSettingsFetched", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("ToolBox.Overviews.ExternalPerson.Types.Msg", [], Msg, () => [[["Item", list_type(ExternalPerson_$reflection())]], [["Item", CustomerConfiguration_$reflection()]], [["Item", list_type(PropertyConfiguration_$reflection())]], [["Item", AccountSettings_$reflection()]], [["Item", class_type("System.Exception")]]]);
}

